'use client';

import { Box } from '@mui/material';
import { useTableOfContents } from "../../../TableOfContents/useTableOfContents";
import { Mobile } from "../../../TableOfContents/Mobile";
import { TableOfContentsHeadingProps } from "../../../TableOfContents/types";
import { COMPONENT_ID_MOBILE } from "../../../TableOfContents/utils";

type Props = {
  headings: TableOfContentsHeadingProps[];
  children: React.ReactNode;
};

export const TableOfContentsContainer = ({ headings, children }: Props) => {
  const { activeId, setActiveId, fireNavigateToSectionPageAction } = useTableOfContents({
    headings,
  });

  return (
    <Box>
      <Box
        component="nav"
        aria-label="Table of contents"
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'sticky',
          top: 0,
          zIndex: 2,
          width: '100%',
          overflow: 'visible',
          paddingBottom: '1.5rem',
        }}
      >
        <Mobile
          distanceToSectionWrapper={1}
          headingLevel={2}
          headings={headings}
          activeId={activeId}
          setActiveId={setActiveId}
          fireNavigateToSectionPageAction={fireNavigateToSectionPageAction}
          tocId={COMPONENT_ID_MOBILE}
        />
      </Box>
      {children}
    </Box>
  );
};
